import { render, staticRenderFns } from "./org-export-setting.vue?vue&type=template&id=35eaddf6&"
import script from "./org-export-setting.vue?vue&type=script&lang=js&"
export * from "./org-export-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports